/**
 * Get JSON data from an API
 * @param {string} url - The API endpoint URL
 * @returns {Promise<Object>} The JSON data
 */
export const getJSON = async function (url) {
  try {
    const res = await fetch(url);
    const data = await res.json();

    if (!res.ok) throw new Error(`${data.message} (${res.status})`);
    return data;
  } catch (err) {
    throw err;
  }
};

/**
 * Send JSON data to an API
 * @param {string} url - The API endpoint URL
 * @param {Object} uploadData - The data to upload
 * @returns {Promise<Object>} The JSON response
 */
export const sendJSON = async function (url, uploadData) {
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(uploadData),
    });

    const data = await res.json();

    if (!res.ok) throw new Error(`${data.message} (${res.status})`);
    return data;
  } catch (err) {
    throw err;
  }
};

